export enum AuthRoutes {
  LOGIN = 'login',
  REGISTRATION = 'registration',
  AUTO_LOGIN = 'autoLogin',
  FORGOT_PASSWORD = 'forgot-password',
  RESET_PASSWORD = 'reset-password',
  EMAIL_VERIFIED = 'email-verified',
  ACCEPT_TC = 'accept-tc',
  SMART_SPRAYER_LANDING = 'smart-sprayer-landing',
  SMART_SPRAYER_REGISTRATION = 'smart-sprayer-registration',
}

const AUTH_ROUTE_SEGMENT_SET = new Set<string>(Object.values(AuthRoutes));

export const getAuthRouteFromPathname = (
  pathname: string,
): AuthRoutes | undefined => {
  const segment = pathname.replace(/\/+$/, '').split('/').pop();
  if (!segment || !AUTH_ROUTE_SEGMENT_SET.has(segment)) {
    return undefined;
  }
  return segment as AuthRoutes;
};
